export default {
    "/introduction/1": ["Demo"],
    "/introduction/3": ["Demo"],
    "/react-d3/1": ["Demo"],
    "/react-d3/2": ["Demo"],
    "/introduction/*": ["RDV_Basic", "RDV_Full", "RDV_AllExtras"],
    "/building-blocks/*": ["RDV_Basic", "RDV_Full", "RDV_AllExtras"],
    "/d3-quick-intro/*": ["RDV_Basic", "RDV_Full", "RDV_AllExtras"],
    "/react-d3/*": ["RDV_Basic", "RDV_Full", "RDV_AllExtras"],
    "/animation/*": ["RDV_Full", "RDV_AllExtras"],
    "/ball-game/*": ["RDV_Full", "RDV_AllExtras"],
    "/canvas-game/*": ["RDV_Full", "RDV_AllExtras"],
    "/choropleth-map/*": ["RDV_Full", "RDV_AllExtras"],
    "/cookbook/*": ["RDV_Full", "RDV_AllExtras"],
    "/downloadable-materials/*": ["RDV_Full", "RDV_AllExtras"],
    "/enter-update-exit/*": ["RDV_Full", "RDV_AllExtras"],
    "/finished/*": ["RDV_Full", "RDV_AllExtras"],
    "/game-loops/*": ["RDV_Full", "RDV_AllExtras"],
    "/load-parse-data/*": ["RDV_Full", "RDV_AllExtras"],
    "/local-environment/*": ["RDV_Full", "RDV_AllExtras"],
    "/make-it-work/*": ["RDV_Full", "RDV_AllExtras"],
    "/meta-info/*": ["RDV_Full", "RDV_AllExtras"],
    "/preloader/*": ["RDV_Full", "RDV_AllExtras"],
    "/react-hooks/*": ["RDV_Full", "RDV_AllExtras"],
    "/redux-animation/*": ["RDV_Full", "RDV_AllExtras"],
    "/salaries-histogram/*": ["RDV_Full", "RDV_AllExtras"],
    "/state-app-structure/*": ["RDV_Full", "RDV_AllExtras"],
    "/simple-animation/*": ["RDV_Full", "RDV_AllExtras"],
    "/smooth-animation/*": ["RDV_Full", "RDV_AllExtras"],
    "/speed-optimizations/*": ["RDV_Full", "RDV_AllExtras"],
    "/swipe-transition/*": ["RDV_Full", "RDV_AllExtras"],
    "/tech-salaries/*": ["RDV_Full", "RDV_AllExtras"],
    "/user-control/*": ["RDV_Full", "RDV_AllExtras"],
    "/using-canvas/*": ["RDV_Full", "RDV_AllExtras"],
  }